import styled from 'styled-components';
import Row from '@sdk/components/ui/spacing/Row';
import Column from '@sdk/components/ui/spacing/Column';
import Text14 from '@sdk/components/ui/typography/Text14';
import View from '@sdk/components/primitives/View';

export const Header = styled(Row)`
  align-items: center;
  display: inline-flex;
  margin-bottom: 10px;
`;

export const ArrowButton = styled(Row)`
  background: ${({ theme }): string => theme.colors.white};
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 4px;
  cursor: pointer;

  &:hover {
    background: ${({ theme }): string => theme.colors.primary};
  }
`;

const ArrowIcon = styled(View)`
  width: 0;
  height: 0;
  border-top: 4px solid transparent;
  border-bottom: 4px solid transparent;
`;

export const LeftArrowIcon = styled(ArrowIcon)`
  ${({ theme }): string => `border-right: 4px solid ${theme.colors.iconGray};`}
  ${ArrowButton}:hover & {
    ${({ theme }): string => `border-right: 4px solid ${theme.colors.white};`}
  }
`;

export const RightArrowIcon = styled(ArrowIcon)`
  ${({ theme }): string => `border-left: 4px solid ${theme.colors.iconGray};`}
  ${ArrowButton}:hover & {
    ${({ theme }): string => `border-left: 4px solid ${theme.colors.white};`}
  }
`;

export const DatepickerTitle = styled(Column)`
  background: ${({ theme }): string => theme.colors.white};
  width: 128px;
  height: 32px;
  border-radius: 4px;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  &:hover {
    background: ${({ theme }): string => theme.colors.primary};
  }
`;

export const DatepickerTitleText = styled(Text14)`
  color: ${({ theme }): string => theme.colors.primary};

  ${DatepickerTitle}:hover & {
    color: ${({ theme }): string => theme.colors.white};
  }
`;
